<template>
  <section class="grid grid-cols-12 gap-4 mb-8">
    <section class="lg:col-span-7 col-span-12">
      <SessionDetailsThumbnail
        :src="baseUrlSrc(sessionDetails && sessionDetails.thumbnail_url)"
        :supportingImages="supportingImages"
        :entityType="sessionDetails && sessionDetails.entity_type"
        :sessionDetails="false"
        :batches="batches"
      />
      <div class="md:mt-4">
          <div class="text-xl text-blacklight font-bold">Description</div>
          <p class="text-base text-blacklight">
            {{ sessionDetails && sessionDetails.description }}
          </p>
      </div>
    </section>
    <section class="lg:col-span-5 col-span-12 lg:pl-12 pl-0 flex flex-col justify-between">
      <div class="p-4 rounded-lg shadow-lg bg-gray-lightest overflow-y-auto">
        <div class="flex justify-between">
          <p class="text-xl text-gray-dark font-semibold capitalize">
            {{ sessionDetails && sessionDetails.title }}
          </p>
          <p class="text-lg text-gray-dark">
            ${{ sessionDetails && sessionDetails.cost }}
          </p>
        </div>
        <div class="text-gray-dark text-base capitalize mb-4">
          {{ sessionDetails && sessionDetails.category_name }}
        </div>
      

        <div class="flex items-center mb-4" v-if="total_count && total_count > 0">
            <Rating :data="average_rating" />
            <p class="text-xs ml-1">
              {{ average_rating }}
              <span class="text-xs text-gray-dark">({{ total_count }})</span>
            </p>
        </div>
        <div class="flex justify-between">
          
          <button
            v-if="trainerSessionView && trainerSessionView.details"
            class="text-xs ring-1 rounded-full ring-green-light text-white bg-green-light px-4 py-2 hover:bg-white hover:text-green-light focus:outline-none"
          >
            <router-link
              v-if="sessionDetails && sessionDetails.course_id"
              :to="{ path: `/trainer/course/${sessionDetails.course_id}` }"
              >View Course</router-link
            >
            <button v-else @click="handleScheduleSession()">
              Schedule Class
            </button>
          </button>
          <button
            v-else
            @click="handleScheduleSession()"
            class="text-xs text-white bg-green-light ring-1 rounded-full ring-green-light px-4 py-2 hover:bg-white hover:text-green-light focus:outline-none"
          >
            Schedule
            {{
              sessionDetails && sessionDetails.entity_type == COURSE
                ? "Course"
                : "Class"
            }}
          </button>
        </div>
      </div>
      
    </section>
  </section>
</template>

<script>
import SessionDetailsThumbnail from "@/components/SessionDetailsThumbnail";
import { Rating } from "@/components/t-components";

export default {
  name: "SessionThumbnailSupporting",
  components: {
    SessionDetailsThumbnail,
    Rating,
  },
  props: {
    data: Array,
    sessionDetails: Object,
    supportingImages: Array,
    average_rating: Number,
    total_count: Number,
    trainerSessionView: Object,
    src: String,
    batches: {
      type: [Array, Object],
    },
    sessions: {
      type: Array,
    },
  },
  data() {
    return {
      SESSION: 1,
    };
  },
  methods: {
    handleScheduleSession() {
      this.$router.push({
        name: "TrainerCalendar",
        query: {
          id: this.sessionDetails && this.sessionDetails.id,
          title: this.sessionDetails && this.sessionDetails.title,
          type: this.sessionDetails && this.sessionDetails.entity_type,
          url: this.sessionDetails && this.sessionDetails.thumbnail_url,
          sessions: this.sessions,
        },
      });
    },
  },
};
</script>